var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ratio-div',_vm._g(_vm._b({},'ratio-div',_vm.$attrs,false),_vm.$listeners),[_c('nio-image',{staticClass:"bg-image",attrs:{"src":_vm.bgSrc}}),_c('div',{staticClass:"mask"}),_c('nio-image',{staticClass:"fr-image",attrs:{"src":_vm.frSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }